import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OrchestratorService } from '@services/orchestrator/orchestrator.service';
import { Observable, catchError, map, of } from 'rxjs';

export const ErrorGuard: CanActivateFn = (): Observable<boolean> => {
  return inject(OrchestratorService)
    .initializeContext()
    .pipe(
      catchError(() => of(undefined)),
      map(() => true)
    );
};
